import { connect } from "react-redux";

import { ApplicationState } from "../../../redux/ApplicationState";
import VideoCard from "../components/VideoCard";

const mapStateToProps = ({ loggedInUserState }: ApplicationState) => ({
  loggedInUser: loggedInUserState.response,
});

export default connect(mapStateToProps, null)(VideoCard);
